import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MailCheck } from "lucide-react";
import { SEO } from "../components/SEO";
import { API, LOGO_MARK } from "../lib/site";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await axios.post(`${API}/password/forgot`, { email });
        } catch {
            /* always show the same confirmation */
        } finally {
            setBusy(false);
            setDone(true);
        }
    };

    return (
        <main>
            <SEO title="Forgot Password | Global Green Hotel" description="Reset your GGH account password." />
            <div className="grain flex min-h-screen items-center justify-center bg-[#04150D] px-5 py-32">
                <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#07211A] p-9" data-testid="forgot-page">
                    <img src={LOGO_MARK} alt="Global Green Hotel logo" className="w-36" />
                    {done ? (
                        <div className="text-left" data-testid="forgot-done">
                            <MailCheck size={36} className="mt-8 text-[#D9B96A]" aria-hidden="true" />
                            <h1 className="font-display mt-5 text-2xl font-medium text-[#FDFBF7]">Check your inbox</h1>
                            <p className="mt-3 text-sm leading-relaxed text-[#FDFBF7]/60">
                                If an account exists for <span className="font-bold text-[#FDFBF7]">{email}</span>,
                                we've sent a password reset link. It is valid for one hour.
                            </p>
                            <Link to="/login" data-testid="forgot-back-login" className="btn-gold mt-8 w-full">
                                Back to Login
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={submit} data-testid="forgot-form">
                            <h1 className="font-display mt-7 text-3xl font-medium text-[#FDFBF7]">Forgot password</h1>
                            <p className="mt-2 text-sm text-[#FDFBF7]/60">
                                Enter the email for your hotel or member account and we'll send you
                                a reset link.
                            </p>
                            <label htmlFor="fp-email" className="mt-8 mb-2 block text-xs font-extrabold uppercase tracking-[0.2em] text-[#FDFBF7]/70">
                                Email
                            </label>
                            <input
                                id="fp-email"
                                data-testid="forgot-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-field"
                                placeholder="you@example.com"
                                autoComplete="email"
                            />
                            <button type="submit" data-testid="forgot-submit" disabled={busy} className="btn-gold mt-7 w-full disabled:cursor-not-allowed disabled:opacity-60">
                                {busy ? "Sending…" : "Send Reset Link"}
                            </button>
                            <p className="mt-6 text-center text-xs text-[#FDFBF7]/50">
                                Remembered it?{" "}
                                <Link to="/login" className="font-bold text-[#D9B96A] hover:underline">
                                    Back to login
                                </Link>
                            </p>
                        </form>
                    )}
                </div>
            </div>
        </main>
    );
};

export default ForgotPassword;
